<template>
  <div class="content">
    <div class="img_box">
      <div class="img_center">
        <div class="img_text">
          <div class="img_title">技术能力</div>
          <div class="img_content"></div>
        </div>
      </div>
    </div>
    <div class="contentCenter" v-for="(item, index) in faceArr" :key="index">
      <div class="title">
        <span>{{ item.leftText }}</span>
      </div>
      <div class="text" v-if="item.text">{{ item.text }}</div>
      <div class="park">
        <div style="width: 69%" class="parkLeft">
          <div
            style="height: 260px; background: #aeb2bd"
            v-for="(items, index) in item.divArr"
            v-lazy-container="{ selector: 'img' }"
            :key="'info1-' + index"
            :style="{
              width: items.width,
              'margin-top': index > 1 ? '15px' : '',
            }"
          >
            <div class="park_box">
              <div class="parkLeft_content">
                <span style="font-size: 16px">{{ items.title }}</span>
                <br />
                <span style="font-size: 12px;display: none">{{ items.titleEng }}</span>
              </div>
              <div class="parkLeft_content1">
                {{ items.content }}
              </div>
            </div>

            <img :data-src="items.url" alt="" />
          </div>
        </div>
        <div
          style="width: 29.5%; height: 535px; background: #aeb2bd"
          class="parkRight"
        >
          <div class="park_box">
            <div class="parkLeft_content">
              <span style="font-size: 16px">人脸检索</span>
              <br />
              <span style="font-size: 12px; display: none">Face retrieval</span>
            </div>
            <div class="parkLeft_content1">
              人脸检索能够针对一个目标人脸,从已有的人脸集合中搜索并返回相似的人脸,同时还会返回相应的置信度分数与阈值,以供人工评估相似度。
            </div>
          </div>
          <img v-lazy="require('../assets/图层 11.png')" alt="" />
        </div>
      </div>
    </div>
    <div
      class="contentCenter"
      v-for="(item, index) in productArr"
      :key="'info2-' + index"
    >
      <div class="title">
        <span>{{ item.leftText }}</span>
      </div>
      <div class="text" v-if="item.text">{{ item.text }}</div>
      <div class="park">
        <div
          class="parkLi"
          v-for="(items, index) in item.picArr"
          v-lazy-container="{ selector: 'img' }"
          :key="'info3-' + index"
        >
          <img :data-src="items.url" alt="" />
          <div class="parkText">
            <div class="parkTextTitle">{{ items.title }}</div>
            <div class="parkSamllText">{{ items.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TechnicAlability",
  data() {
    return {
      faceArr: [
        {
          leftText: "人脸识别",
          text: "可检测单人及多人场景 不仅可以支持单人的姿态预估,同时有效支持多人场景下的人体检测",
          divArr: [
            {
              width: "49%",
              url: require("../assets/图层 3.png"),
              title: "人脸识别",
              titleEng: "Face recognition",
              content:
                "使用先进的高准确度的人脸识别技术，检测率与识别率上都有保障，并且错误率小，稳定性高。",
            },
            {
              width: "49%",
              url: require("../assets/图层 12.png"),
              title: "人脸对比",
              titleEng: "Face comparison",

              content:
                "通过识别并提取人脸特征,对人像进行高精度比对,给出置信度分数,判断对象是否为同一个人。",
            },
            {
              width: "32%",
              url: require("../assets/图层 5.png"),
              title: "人脸轨迹",
              titleEng: "Face trajectory",

              content:
                "支持人脸轨迹功能，可以在地图上显示相关人员的轨迹，进行可视化研判。",
            },
            {
              width: "32%",
              url: require("../assets/图层 10.png"),
              title: "人脸聚类",
              titleEng: "Face clustering",

              content:
                "人脸聚类是将一个集合内的人脸根据身份进行分组的算法， 人脸聚类也通过将集合内所有的人脸两两之间做人脸比对，再根据这些相似度值进行分析，将属于同一个身份的人划分到一个组里。",
            },
            {
              width: "32%",
              url: require("../assets/图层 9.png"),
              title: "人脸属性",
              titleEng: "Face attributes",

              content:
                "人脸属性识别与算法 人脸是一种非常重要的生物特征,具有结构复杂、细节变化多等特点,同时也蕴含了大量的信息,比如性别、种族、年龄、表情等。",
            },
          ],
        },
      ],
      productArr: [
        {
          leftText: "人体检测",
          text: "可检测单人及多人场景 不仅可以支持单人的姿态预估,同时有效支持多人场景下的人体检测",
          picArr: [
            {
              url: require("../assets/图层 13.png"),
              title: "人体检测",
              text: "可检测单人及多人场景 不仅可以支持单人的姿态预估,同时有效支持多人场景下的人体检测。 识别角度支持平俯视角识别",
            },
            {
              url: require("../assets/图层 14.png"),
              title: "人体关键点定位",
              text: "精准定位人体的14个主要关键点,包含鼻子/颈部/四肢等主要关节部位,可应用于体育健身,娱乐互动,安防监控等场景,分析人体动作和姿态",
            },
            {
              url: require("../assets/椭圆 1 拷贝 2.png"),
              title: "跌倒检测",
              text: "不依靠穿戴设备和传感器，是一种基于深度学习图像处理的摔倒检测方法，对摄像头拍摄的视频或图片即可检测是否摔倒",
            },
          ],
        },
        {
          leftText: "表情识别",
          text: "通过提取图片特征进行机器学习,并使用深度神经网络进行分析。可以实现在复杂的环境下有效地对人脸表情进行识别,并在准确度上有所保障。",
          picArr: [
            {
              url: require("../assets/图层 15.png"),
              title: "表情识别",
              text: "通过提取图片特征进行机器学习,并使用深度神经网络进行分析。可以实现在复杂的环境下有效地对人脸表情进行识别,并在准确度上有所保障。",
            },
            {
              url: require("../assets/tzlnu.png"),
              title: "情绪识别",
              text: "精准定位人体的14个主要关键点,包含鼻子/颈部/四肢等主要关节部位,可应用于体育健身,娱乐互动,安防监控等场景,分析人体动作和姿态",
            },
            {
              url: require("../assets/图层 17.png"),
              title: "心理分析",
              text: "运用层次分析法建立用户心理体验评价的层次结构模型，运用深度置信网络（DBN）进行用户心理体验评价",
            },
          ],
        },
        {
          leftText: "其他",
          text: "",
          picArr: [
            {
              url: require("../assets/图层 18.png"),
              title: "老鼠识别",
              text: "使用目标检测技术、目标分类技术以及快速训练技术实现对老鼠的准确识别，识别精度可达95.5%，对鼠害防治有极大意义。",
            },
            {
              url: require("../assets/图层 19.png"),
              title: "着装检测",
              text: "基于视频流的智能图像识别系统，利用最新的深度学习与大数据技术，代替人眼，自动识别各种违规行为，为安全生产保驾护航。",
            },
            {
              url: require("../assets/图层 20.png"),
              title: "桌面整洁度检测",
              text: "利用Faster-RCNN算法对待检测区域进行特征学习和目标分类,代替肉眼观察，实现桌面异物识别，降低人力成本提高检查工作效率。",
            },
          ],
        },
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>
.title {
  font-size: 40px;
  color: #333;
}
.title > span:nth-of-type(2) {
  color: #0171bb;
}
.img_box {
  width: 100%;
  height: 400px;
  background-image: url(../assets/Technical.jpg);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #464646;
}
.img_center {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-weight: 400;
  color: #ffffff;
}
.img_title {
  width: 100%;
  margin-top: 173px;
  font-size: 60px;
}
.img_content {
  width: 1000px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 20px;
  margin-top: 26px;
}
.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 80px;
}
@media (min-width: 768px) {
  .contentCenter {
    width: 800px;
  }
}
@media (min-width: 1000px) {
  .contentCenter {
    width: 970px;
  }
}
@media (min-width: 1280px) {
  .contentCenter {
    width: 1200px;
  }
}
.title {
  text-align: center;
  margin-top: 100px;
  font-size: 40px;
  color: #333;
}
.text {
  text-align: center;
  font-size: 14px;
  color: #404040;
  margin-top: 10px;
}
.park {
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
}
.parkLi {
  width: 32%;
  position: relative;
  overflow: hidden;
}
.parkLi > img {
  width: 100%;
}
.parkText {
  padding: 30px 20px;
  box-sizing: border-box;
  min-height: 180px;
  border: 1px solid #aeb2bd;
  border-top: none;
  font-size: 14px;
  width: 100%;
}
.parkTextTitle {
  font-size: 18px;
  font-weight: bold;
  color: #404040;
}
.parkSamllText {
  color: #404040;
  margin-top: 10px;
}
.parkLeft {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
}
.parkLeft > div {
  overflow: hidden;
}
.parkRight > img {
  width: 100%;
  height: 100%;
}
.parkRight {
  overflow: hidden;
  position: relative;
}
.parkRight:hover > div {
  display: block !important;
  animation: fadeinout 0.6s linear forwards;
}
.parkLeft_content {
  width: 160px;
  /* height: 50px; */
  background: #0171bb;
  position: absolute;
  top: 37px;
  padding-left: 23px;
  padding-top: 8px;
  padding-bottom: 8px;
  color: #ffffff;
}
.parkLeft > div {
  position: relative;
}
.park_box {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #29335670;
  display: none;
}
.parkLeft > div:hover > div {
  display: block;
  animation: fadeinout 0.6s linear forwards;
}
@keyframes fadeinout {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.parkLeft_content1 {
  position: absolute;
  font-size: 14px;
  line-height: 21px;
  color: #fff;
  top: 110px;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  /* text-indent: 2em; */
}
@media (max-width: 1200px) {
  .parkLeft_content1 {
    width: auto;
  }
  .content > div img {
    height: 70%;
  }
  .content > div:nth-of-type(1) img {
    width: 100%;
    height: 100%;
  }
}
@media (max-width: 425px) {
  .title > span {
    font-size: 30px !important;
  }
  .content {
    padding-bottom: 30px;
  }
  .park {
    flex-direction: column;
    margin-top: 40px;
    width: 100% !important;
  }
  .title {
    margin-top: 50px;
  }

  .text {
    padding: 0 15px;
    margin: 0;
    width: 100%;
    font-size: 12px !important;
    margin-top: 20px;
  }
  .parkLeft {
    width: 100% !important;
  }
  .parkLeft > div {
    width: 100% !important;
    margin-top: 0 !important;
  }
  .parkRight {
    width: 100% !important;
    height: 250px !important;
  }
  .parkLi {
    width: 100%;
    height: 350px;
  }
  .parkText {
    padding: 10px;
    height: 30%;
    border: none;
  }
  .img_center {
    width: 100%;
  }
  .img_title {
    font-weight: bold;
    font-size: 30px;
    margin-top: 100px;
  }
  .img_content {
    font-size: 12px;
    line-height: 18px;
    /* text-indent: 2em; */
    width: 90%;
    margin-top: 20px;
  }
  .img_box {
    height: 270px;
  }
  .content > div img {
    /* height: 80%; */
    width: 100%;
  }
  .parkLeft > div {
    height: auto;
  }
  .parkLeft_content1 {
    font-size: 12px;
    top: 110px;
  }
  .parkSamllText {
    font-size: 12px;
    color: #666;
  }
  .content > div:nth-of-type(2) img {
    height: 100%;
    object-fit: cover;
  }
  .parkTextTitle {
    font-size: 15px;
  }
  .park_box {
    background-color: #2933564d;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/technicAlability.vue